"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _ComponentContainer = require("../../../Framework/ComponentContainer");
var _Progress = _interopRequireDefault(require("../Components/Progress/Progress"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    Component: _Progress["default"],
    loading: (0, _get["default"])(state, 'ui.visibilityMap.globalLoader', false) || (0, _get["default"])(state, 'ui.visibilityMap.loadVisualization', false)
  };
};
var _default = exports["default"] = (0, _ComponentContainer.containerConnect)(mapStateToProps);